import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { Close, CheckCircle } from "@material-ui/icons";
import guid from "../../helpers/guid.helper";
import { getCommision } from "../../helpers/general.helper";
import { connect } from "react-redux";
import "./baggage.css";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: "4%",
    marginBottom: "2%",
  },
  main: {
    paddingTop: "10%",
    backgroundColor: "rgb(246, 249, 252)",
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "32%",
    },
  },
}));
const currency = localStorage.getItem("selectedCurrency");
function Baggage(props) {
  const classes = useStyles();

  const [selectedCabinBaggage, setSelectedCabinBaggage] = useState(null);
  const [selectedCabinBaggageInd, setSelectedCabinBaggageInd] = useState(null);

  const [selectedCheckedBaggage, setSelectedCheckedBaggage] = useState(null);
  const [selectedCheckedBaggageInd, setSelectedCheckedBaggageInd] = useState(
    null
  );

  useEffect(() => {
    props.onBaggageChange &&
      props.onBaggageChange({
        cabinBaggage: selectedCabinBaggage,
        checkedBaggage: selectedCheckedBaggage,
      });
  }, [selectedCabinBaggage, selectedCheckedBaggage]);

  const { flight } = props;
  useEffect(() => {
    if (!flight) return;
    let baggage = flight.baggage;
    let cabin_baggage = baggage?.combinations?.hand_bag;
    let checked_baggage = baggage?.combinations?.hold_bag;

    cabin_baggage &&
      cabin_baggage.map((baggage, i) => {
        if (
          props.category &&
          baggage.conditions &&
          baggage.conditions.passenger_groups &&
          baggage.conditions.passenger_groups.length
        ) {
          if (!baggage.conditions.passenger_groups.includes(props.category)) {
            setSelectedCabinBaggage(null);
            setSelectedCabinBaggageInd(null);
          }
        }
      });

    checked_baggage &&
      checked_baggage.map((baggage, i) => {
        if (
          props.category &&
          baggage.conditions &&
          baggage.conditions.passenger_groups &&
          baggage.conditions.passenger_groups.length
        ) {
          if (!baggage.conditions.passenger_groups.includes(props.category)) {
            setSelectedCheckedBaggage(null);
            setSelectedCheckedBaggageInd(null);
          }
        }
      });
  }, [props.category]);

  if (!flight || !flight.baggage) return <></>;
  let baggage = flight.baggage;

  let cabin_definitions = baggage?.definitions?.hand_bag;
  let checked_definitions = baggage?.definitions?.hold_bag;
  let cabin_baggage = baggage?.combinations?.hand_bag;
  let checked_baggage = baggage?.combinations?.hold_bag;

  const handleCabinBaggageSelect = (data, ind) => {
    setSelectedCabinBaggage(data);
    setSelectedCabinBaggageInd(ind);
  };
  const handleCheckedBaggageSelect = (data, ind) => {
    setSelectedCheckedBaggage(data);
    setSelectedCheckedBaggageInd(ind);
  };

  const getBaggagePrice = (flight, baggage) => {
    if (flight && flight.conversion && baggage.price.amount) {
      const bPrice = Object.values(flight.conversion);
      let baggagePrice = (bPrice[1] / bPrice[0]) * baggage.price.amount;
      if (baggagePrice == 0) return baggagePrice;

      return (
        baggagePrice +
        getCommision(
          baggagePrice,
          props.commissionType,
          props.commissionValue
        ) +
        getCommision(
          baggagePrice,
          props.adminCommissionType,
          props.adminCommissionValue
        )
      ).toFixed(2);
    }
    return 0;
  };

  return (
    <>
      <div className="desktop-list">
        <Grid container>
          <Typography
            component="p"
            style={{ marginTop: "20px", fontWeight: 600 }}
          >
            Cabin Baggage
          </Typography>
          <Grid item xs="12">
            {cabin_baggage &&
              cabin_baggage.length > 0 &&
              cabin_baggage.map((baggage, i) => {
                if (
                  props.category &&
                  baggage.conditions &&
                  baggage.conditions.passenger_groups &&
                  baggage.conditions.passenger_groups.length
                ) {
                  if (
                    baggage.conditions.passenger_groups.includes(props.category)
                  ) {
                    if (baggage.indices && baggage.indices.length > 0) {
                      return (
                        <div
                          className={`baggage-box ${
                            i == selectedCabinBaggageInd ? "blue-ol" : ""
                          }`}
                          onClick={() => handleCabinBaggageSelect(baggage, i)}
                        >
                          <Grid container spacing={0}>
                            <Grid item xs="2" sm="2" md="1">
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop:
                                    baggage.indices.length > 1
                                      ? "30px"
                                      : "12px",
                                }}
                              >
                                <div
                                  className={` ${
                                    i == selectedCabinBaggageInd
                                      ? "baggage-radio-btn"
                                      : "baggage-radio-btn-inactive"
                                  }`}
                                ></div>
                              </div>
                            </Grid>
                            <Grid item xs="7" sm="7" md="8">
                              {baggage.indices.map((indice) => {
                                let baggage_def =
                                  cabin_definitions &&
                                  cabin_definitions[indice];

                                return (
                                  <Grid container>
                                    <Grid item xs="12" sm="12" md="8">
                                      <Grid container>
                                        <Grid item xs="2" sm="4" md="2">
                                          <div
                                            style={{
                                              // padding: 5,
                                              display: "inline-block",
                                              // margin: "5px 5px",
                                              textAlign: "left",
                                            }}
                                          >
                                            {baggage_def.category ===
                                              "personal_item" && (
                                              <a
                                                style={{
                                                  fontSize: 24,
                                                  display: "block",
                                                  backgroundColor:
                                                    "var(--white)",
                                                  padding: "5px 10px",
                                                  color: "var(--darker)",
                                                  borderRadius: "5px",
                                                  marginBottom: "2px",
                                                }}
                                              >
                                                {" "}
                                                <i className="fa fa-suitcase"></i>
                                              </a>
                                            )}

                                            {baggage_def.category ===
                                              "cabin_bag" && (
                                              <a
                                                style={{
                                                  fontSize: 24,
                                                  display: "block",
                                                  backgroundColor:
                                                    "var(--white)",
                                                  padding: "5px 10px",
                                                  color: "var(--darker)",
                                                  borderRadius: "5px",
                                                  marginBottom: "2px",
                                                }}
                                              >
                                                {" "}
                                                <svg
                                                  class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium  css-w2bhrx"
                                                  focusable="false"
                                                  viewBox="0 0 24 24"
                                                  aria-hidden="true"
                                                  data-testid="LuggageIcon"
                                                  aria-label="fontSize medium"
                                                >
                                                  <path d="M17 6h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9.5 18H8V9h1.5v9zm3.25 0h-1.5V9h1.5v9zm.75-12h-3V3.5h3V6zM16 18h-1.5V9H16v9z"></path>
                                                </svg>
                                              </a>
                                            )}
                                          </div>{" "}
                                        </Grid>

                                        <Grid
                                          item
                                          xs="8"
                                          sm="8"
                                          md="6"
                                          style={{ textAlign: "left" }}
                                        >
                                          <div
                                            style={{
                                              padding: 5,
                                              display: "inline-block",
                                              margin: 5,
                                              marginTop: "8px",
                                            }}
                                          >
                                            <Typography
                                              component="span"
                                              style={{ textAlign: "left" }}
                                              className={classes.baggageText}
                                            >
                                              {" "}
                                              {baggage_def.category ===
                                                "personal_item" &&
                                                "Personal Item"}
                                            </Typography>
                                            <Typography
                                              component="p"
                                              style={{ textAlign: "left" }}
                                            >
                                              {baggage_def.category ===
                                                "cabin_bag" && "Cabin Baggage"}
                                            </Typography>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item xs="12" sm="12" md="4">
                                      <div
                                        style={{
                                          padding: 5,
                                          marginTop: "10px",
                                          textAlign: "left",
                                        }}
                                      >
                                        <Typography component="p">
                                          {baggage_def &&
                                          baggage_def.restrictions
                                            ? `${baggage_def.restrictions.length} x ${baggage_def.restrictions.width} x ${baggage_def.restrictions.height} cm, ${baggage_def.restrictions.weight} kg`
                                            : ""}
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                );
                              })}
                            </Grid>
                            <Grid item xs="3" sm="3" md="3">
                              <Typography
                                style={{
                                  padding: 5,
                                  fontWeight: "bold",
                                  fontSize: 18,
                                  fontWeight: "bold",
                                  marginTop: "10px",
                                }}
                              >
                                {props.selectedCurrency}{" "}
                                {getBaggagePrice(flight, baggage)}
                                {/* {flight &&
                              flight.conversion &&
                              flight.conversion.amount &&
                              flight.total &&
                              baggage.price.amount &&
                              (((flight.conversion.amount / flight.total) *
                                baggage.price.amount)+ getCommision(baggagePrice,props.commissionType,props.commissionValue)+
                                getCommision(baggagePrice,props.adminCommissionType,props.adminCommissionValue)).toFixed(2)} */}
                              </Typography>
                            </Grid>
                          </Grid>
                        </div>
                      );
                    }
                  }
                }
              })}
          </Grid>
          <Typography
            component="p"
            style={{ textAlign: "left", marginTop: "10px", fontWeight: 600 }}
          >
            Checked Baggage
          </Typography>

          <Grid item xs="12">
            {checked_baggage &&
              checked_baggage.length > 0 &&
              checked_baggage.map((baggage, i) => {
                if (
                  props.category &&
                  baggage.conditions &&
                  baggage.conditions.passenger_groups &&
                  baggage.conditions.passenger_groups.length
                ) {
                  if (
                    baggage.conditions.passenger_groups.includes(props.category)
                  ) {
                    if (baggage.indices && baggage.indices.length > 0) {
                      return (
                        <div
                          className={`baggage-box ${
                            i == selectedCheckedBaggageInd ? "blue-ol" : ""
                          }`}
                          onClick={() => handleCheckedBaggageSelect(baggage, i)}
                        >
                          <Grid container spacing={0}>
                            <Grid item xs="2" sm="2" md="1">
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop:
                                    baggage &&
                                    baggage.indices &&
                                    baggage.indices.length > 1
                                      ? "30px"
                                      : "12px",
                                }}
                              >
                                <div
                                  className={`${
                                    i == selectedCheckedBaggageInd
                                      ? "baggage-radio-btn"
                                      : "baggage-radio-btn-inactive"
                                  }`}
                                ></div>
                              </div>
                            </Grid>
                            <Grid item xs="7" sm="7" md="8">
                              {baggage.indices.map((indice) => {
                                let baggage_def =
                                  checked_definitions &&
                                  checked_definitions[indice];

                                return (
                                  <Grid container>
                                    <Grid item xs="12" sm="12" md="8">
                                      <Grid container>
                                        <Grid item xs="2" sm="4" md="2">
                                          <div
                                            style={{
                                              display: "inline-block",
                                            }}
                                          >
                                            {baggage_def.category ===
                                              "hold_bag" && (
                                              <a
                                                style={{
                                                  display: "block",
                                                  fontSize: 24,
                                                  backgroundColor:
                                                    "var(--white)",
                                                  padding: "5px 10px",
                                                  color: "var(--darker)",
                                                  borderRadius: "5px",
                                                  marginBottom: "2px",
                                                }}
                                              >
                                                {" "}
                                                <svg
                                                  class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium  css-w2bhrx"
                                                  focusable="false"
                                                  viewBox="0 0 24 24"
                                                  aria-hidden="true"
                                                  data-testid="LuggageIcon"
                                                  aria-label="fontSize medium"
                                                >
                                                  <path d="M17 6h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9.5 18H8V9h1.5v9zm3.25 0h-1.5V9h1.5v9zm.75-12h-3V3.5h3V6zM16 18h-1.5V9H16v9z"></path>
                                                </svg>
                                              </a>
                                            )}
                                          </div>{" "}
                                        </Grid>
                                        <Grid
                                          item
                                          xs="8"
                                          sm="8"
                                          md="10"
                                          style={{ textAlign: "left" }}
                                        >
                                          <div
                                            style={{
                                              padding: 5,
                                              display: "inline-block",
                                              margin: 5,
                                              marginTop: "8px",
                                            }}
                                          >
                                            <Typography component="p">
                                              {" "}
                                              {baggage_def &&
                                              baggage_def.restrictions &&
                                              baggage_def.restrictions.weight
                                                ? `${baggage_def.restrictions.weight} kg`
                                                : ""}{" "}
                                              Checked Baggage
                                            </Typography>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item xs="12" sm="12" md="4">
                                      <div
                                        style={{
                                          padding: 5,
                                          marginTop: "10px",
                                          textAlign: "left",
                                        }}
                                      >
                                        <Typography
                                          component="p"
                                          className={classes.baggageText}
                                        >
                                          {baggage_def &&
                                          baggage_def.restrictions
                                            ? `${baggage_def.restrictions.length} x ${baggage_def.restrictions.width} x ${baggage_def.restrictions.height} cm, ${baggage_def.restrictions.weight} kg`
                                            : ""}
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                );
                              })}
                            </Grid>
                            <Grid item xs="3" sm="3" md="3">
                              <Typography
                                style={{
                                  padding: 5,
                                  fontWeight: "bold",
                                  fontSize: 18,
                                  fontWeight: "bold",
                                  marginTop: "10px",
                                }}
                              >
                                {props.selectedCurrency}{" "}
                                {getBaggagePrice(flight, baggage)}
                                {/* {flight &&
                              flight.conversion &&
                              flight.conversion.amount &&
                              flight.total &&
                              baggage.price.amount &&
                              ((flight.conversion.amount / flight.total) *
                                baggage.price.amount).toFixed(2)} */}
                              </Typography>
                            </Grid>
                          </Grid>
                        </div>
                      );
                    }
                  }
                }
              })}
            <div
              onClick={() => {
                handleCheckedBaggageSelect(null, -1);
              }}
              className={`baggage-box ${
                selectedCheckedBaggageInd === -1 ? "blue-ol" : ""
              }`}
            >
              <Grid container>
                <Grid item md="1" sm="2" xs="2">
                  <div style={{ textAlign: "center", marginTop: "7px" }}>
                    <div
                      className={
                        selectedCheckedBaggageInd == -1
                          ? "baggage-radio-btn"
                          : "baggage-radio-btn-inactive"
                      }
                    ></div>
                  </div>
                </Grid>
                <Grid item md="1" sm="2" xs="2" style={{ textAlign: "left" }}>
                  <div
                    style={{
                      display: "inline-block",
                      fontSize: 20,
                      color: "var(--darker)",
                    }}
                  >
                    {" "}
                    <a
                      style={{
                        marginLeft: "15px",
                        display: "block",
                        backgroundColor: "var(--white)",
                        padding: "5px 10px",
                        color: "var(--darker)",
                        borderRadius: "5px",
                      }}
                    >
                      {" "}
                      <Close />
                    </a>
                  </div>
                </Grid>
                <Grid item md="10" sm="8" xs="8" style={{ textAlign: "left" }}>
                  <div
                    style={{
                      padding: 5,
                      display: "inline-block",
                      marginTop: 5,
                    }}
                  >
                    {" "}
                    <Typography component="p">
                      I don't need a checked baggage bundle
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className="mobile-list">
        <Grid container>
          <Typography
            component="p"
            style={{ marginTop: "20px", fontWeight: 600 }}
          >
            Cabin Baggage
          </Typography>
          <Grid item xs="12">
            {cabin_baggage &&
              cabin_baggage.length > 0 &&
              cabin_baggage.map((baggage, i) => {
                if (
                  props.category &&
                  baggage.conditions &&
                  baggage.conditions.passenger_groups &&
                  baggage.conditions.passenger_groups.length
                ) {
                  if (
                    baggage.conditions.passenger_groups.includes(props.category)
                  ) {
                    if (baggage.indices && baggage.indices.length > 0) {
                      return (
                        <div
                          className={`baggage-box ${
                            i == selectedCabinBaggageInd ? "blue-ol" : ""
                          }`}
                          onClick={() => handleCabinBaggageSelect(baggage, i)}
                        >
                          <Grid container spacing={0}>
                            <Grid container spacing={0}>
                              <Grid item xs="2" sm="2" md="1">
                                <div
                                  style={{
                                    textAlign: "center",
                                    marginTop:
                                      baggage.indices.length > 1
                                        ? "30px"
                                        : "12px",
                                  }}
                                >
                                  <div
                                    className={` ${
                                      i == selectedCabinBaggageInd
                                        ? "baggage-radio-btn-mobile"
                                        : "baggage-radio-btn-inactive-mobile"
                                    } item-size-mob`}
                                  ></div>
                                </div>
                              </Grid>
                              <Grid item xs="10" sm="10" md="8">
                                {baggage.indices.map((indice) => {
                                  let baggage_def =
                                    cabin_definitions &&
                                    cabin_definitions[indice];

                                  return (
                                    <Grid container>
                                      <Grid item xs="12" sm="12" md="8">
                                        <Grid container>
                                          <Grid item xs="2" sm="4" md="2">
                                            <div
                                              style={{
                                                // padding: 5,
                                                display: "inline-block",
                                                // margin: "5px 5px",
                                                textAlign: "left",
                                              }}
                                            >
                                              {baggage_def.category ===
                                                "personal_item" && (
                                                <a
                                                  style={{
                                                    display: "block",
                                                    backgroundColor:
                                                      "var(--white)",
                                                    padding: "5px",
                                                    color: "var(--darker)",
                                                    borderRadius: "5px",
                                                    marginBottom: "2px",
                                                    marginTop: "10px",
                                                  }}
                                                  className="item-size-mob"
                                                >
                                                  {" "}
                                                  <i
                                                    className="fa fa-suitcase"
                                                    style={{ width: "100%" }}
                                                  ></i>
                                                </a>
                                              )}

                                              {baggage_def.category ===
                                                "cabin_bag" && (
                                                <a
                                                  style={{
                                                    display: "block",
                                                    backgroundColor:
                                                      "var(--white)",
                                                    padding: "5px",
                                                    color: "var(--darker)",
                                                    borderRadius: "5px",
                                                    marginBottom: "2px",
                                                    marginTop: "10px",
                                                  }}
                                                  className="item-size-mob"
                                                >
                                                  {" "}
                                                  <svg
                                                    class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium  css-w2bhrx"
                                                    style={{ width: "100%" }}
                                                    focusable="false"
                                                    viewBox="0 0 24 24"
                                                    aria-hidden="true"
                                                    data-testid="LuggageIcon"
                                                    aria-label="fontSize medium"
                                                  >
                                                    <path d="M17 6h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9.5 18H8V9h1.5v9zm3.25 0h-1.5V9h1.5v9zm.75-12h-3V3.5h3V6zM16 18h-1.5V9H16v9z"></path>
                                                  </svg>
                                                </a>
                                              )}
                                            </div>{" "}
                                          </Grid>

                                          <Grid
                                            item
                                            xs="10"
                                            sm="8"
                                            md="6"
                                            style={{ textAlign: "left" }}
                                          >
                                            <div
                                              style={{
                                                display: "inline-block",
                                                margin: 5,
                                                marginTop: "8px",
                                              }}
                                            >
                                              <Typography
                                                component="span"
                                                style={{ textAlign: "left" }}
                                                className="item-size-mob"
                                              >
                                                {" "}
                                                {baggage_def.category ===
                                                  "personal_item" &&
                                                  "Personal Item"}
                                              </Typography>
                                              <Typography
                                                component="p"
                                                style={{ textAlign: "left" }}
                                                className={`${classes.baggageText} item-size-mob`}
                                              >
                                                {baggage_def.category ===
                                                  "cabin_bag" &&
                                                  "Cabin Baggage"}
                                              </Typography>
                                              <Typography
                                                component="p"
                                                className={`${classes.baggageText} item-size-mob`}
                                              >
                                                {baggage_def &&
                                                baggage_def.restrictions
                                                  ? `${baggage_def.restrictions.length} x ${baggage_def.restrictions.width} x ${baggage_def.restrictions.height} cm, ${baggage_def.restrictions.weight} kg`
                                                  : ""}
                                              </Typography>
                                            </div>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            </Grid>
                            <Grid item xs="12" sm="12" md="3">
                              <Typography
                                style={{
                                  padding: 5,
                                  fontWeight: "bold",
                                  fontSize: 18,
                                  fontWeight: "bold",
                                  marginTop: "10px",
                                }}
                              >
                                {props.selectedCurrency}{" "}
                                {getBaggagePrice(flight, baggage)}
                                {/* {flight &&
                                  flight.conversion &&
                                  flight.conversion.amount &&
                                  flight.total &&
                                  baggage.price.amount &&
                                  (
                                    (flight.conversion.amount / flight.total) *
                                    baggage.price.amount
                                  ).toFixed(2)} */}
                              </Typography>
                            </Grid>
                          </Grid>
                        </div>
                      );
                    }
                  }
                }
              })}
          </Grid>
          <Typography
            component="p"
            style={{ textAlign: "left", marginTop: "10px", fontWeight: 600 }}
          >
            Checked Baggage
          </Typography>

          <Grid item xs="12">
            {checked_baggage &&
              checked_baggage.length > 0 &&
              checked_baggage.map((baggage, i) => {
                if (
                  props.category &&
                  baggage.conditions &&
                  baggage.conditions.passenger_groups &&
                  baggage.conditions.passenger_groups.length
                ) {
                  if (
                    baggage.conditions.passenger_groups.includes(props.category)
                  ) {
                    if (baggage.indices && baggage.indices.length > 0) {
                      return (
                        <div
                          className={`baggage-box ${
                            i == selectedCheckedBaggageInd ? "blue-ol" : ""
                          }`}
                          onClick={() => handleCheckedBaggageSelect(baggage, i)}
                        >
                          <Grid container className="" spacing={0}>
                            <Grid container spacing={0}>
                              <Grid item xs="2" sm="2" md="1">
                                <div
                                  style={{
                                    textAlign: "center",
                                    marginTop:
                                      baggage &&
                                      baggage.indices &&
                                      baggage.indices.length > 1
                                        ? "30px"
                                        : "12px",
                                  }}
                                >
                                  <div
                                    className={`${
                                      i == selectedCheckedBaggageInd
                                        ? "baggage-radio-btn-mobile"
                                        : "baggage-radio-btn-inactive-mobile"
                                    }`}
                                  ></div>
                                </div>
                              </Grid>
                              <Grid item xs="10" sm="10" md="8">
                                {baggage.indices.map((indice) => {
                                  let baggage_def =
                                    checked_definitions &&
                                    checked_definitions[indice];

                                  return (
                                    <Grid container>
                                      <Grid item xs="12" sm="12" md="8">
                                        <Grid container>
                                          <Grid item xs="2" sm="4" md="2">
                                            <div
                                              style={{
                                                display: "inline-block",
                                              }}
                                            >
                                              {baggage_def.category ===
                                                "hold_bag" && (
                                                <a
                                                  style={{
                                                    display: "block",
                                                    backgroundColor:
                                                      "var(--white)",
                                                    padding: "5px",
                                                    color: "var(--darker)",
                                                    borderRadius: "5px",
                                                    marginBottom: "2px",
                                                    marginTop: "10px",
                                                  }}
                                                  className="item-size-mob"
                                                >
                                                  {" "}
                                                  <svg
                                                    class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium  css-w2bhrx"
                                                    focusable="false"
                                                    style={{ width: "100%" }}
                                                    viewBox="0 0 24 24"
                                                    aria-hidden="true"
                                                    data-testid="LuggageIcon"
                                                    aria-label="fontSize medium"
                                                  >
                                                    <path d="M17 6h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9.5 18H8V9h1.5v9zm3.25 0h-1.5V9h1.5v9zm.75-12h-3V3.5h3V6zM16 18h-1.5V9H16v9z"></path>
                                                  </svg>
                                                </a>
                                              )}
                                            </div>{" "}
                                          </Grid>
                                          <Grid
                                            item
                                            xs="10"
                                            sm="8"
                                            md="6"
                                            style={{ textAlign: "left" }}
                                          >
                                            <div
                                              style={{
                                                display: "inline-block",
                                                margin: 5,
                                                marginTop: "8px",
                                              }}
                                            >
                                              <Typography
                                                component="p"
                                                className="item-size-mob"
                                              >
                                                {" "}
                                                {baggage_def &&
                                                baggage_def.restrictions &&
                                                baggage_def.restrictions.weight
                                                  ? `${baggage_def.restrictions.weight} kg`
                                                  : ""}{" "}
                                                Checked Baggage
                                              </Typography>
                                              <Typography
                                                component="p"
                                                className={`${classes.baggageText} item-size-mob`}
                                              >
                                                {baggage_def &&
                                                baggage_def.restrictions
                                                  ? `${baggage_def.restrictions.length} x ${baggage_def.restrictions.width} x ${baggage_def.restrictions.height} cm, ${baggage_def.restrictions.weight} kg`
                                                  : ""}
                                              </Typography>
                                            </div>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            </Grid>
                            <Grid item xs="12" sm="12" md="3">
                              <Typography
                                style={{
                                  padding: 5,
                                  fontWeight: "bold",
                                  fontSize: 18,
                                  fontWeight: "bold",
                                  marginTop: "10px",
                                }}
                              >
                                {props.selectedCurrency}{" "}
                                {getBaggagePrice(flight, baggage)}
                                {/* {flight &&
                                  flight.conversion &&
                                  flight.conversion.amount &&
                                  flight.total &&
                                  baggage.price.amount &&
                                  (
                                    (flight.conversion.amount / flight.total) *
                                    baggage.price.amount
                                  ).toFixed(2)} */}
                              </Typography>
                            </Grid>
                          </Grid>
                        </div>
                      );
                    }
                  }
                }
              })}
            <div
              onClick={() => {
                handleCheckedBaggageSelect(null, -1);
              }}
              className={`baggage-box ${
                selectedCheckedBaggageInd === -1 ? "blue-ol" : ""
              }`}
            >
              <Grid container>
                <Grid item md="1" sm="2" xs="2">
                  <div style={{ textAlign: "center", marginTop: "7px" }}>
                    <div
                      className={
                        selectedCheckedBaggageInd == -1
                          ? "baggage-radio-btn-mobile"
                          : "baggage-radio-btn-inactive-mobile"
                      }
                    ></div>
                  </div>
                </Grid>
                <Grid item md="8" sm="10" xs="10">
                  <Grid container>
                    <Grid item xs="12" sm="12" md="8">
                      <Grid container>
                        <Grid
                          item
                          md="1"
                          sm="4"
                          xs="2"
                          style={{ textAlign: "left" }}
                        >
                          <div
                            style={{
                              display: "inline-block",
                              color: "var(--darker)",
                            }}
                          >
                            {" "}
                            <a
                              style={{
                                display: "block",
                                backgroundColor: "var(--white)",
                                padding: "5px",
                                color: "var(--darker)",
                                borderRadius: "5px",
                              }}
                              className="item-size-mob"
                            >
                              {" "}
                              <Close style={{ width: "100%" }} />
                            </a>
                          </div>
                        </Grid>
                        <Grid
                          item
                          md="6"
                          sm="8"
                          xs="10"
                          style={{ textAlign: "left" }}
                        >
                          <div
                            style={{
                              display: "inline-block",
                              margin: 5,
                              marginTop: "8px",
                            }}
                          >
                            {" "}
                            <Typography component="p" className="item-size-mob">
                              I don't need a checked baggage bundle
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

// export default React.memo(Baggage);
const mapStateWithProps = (state) => {
  let commissionType = "";
  let commissionValue = 0;
  let vendorCurrency;
  if (state.vendor && state.vendor.vendorDetail) {
    commissionType = state.vendor.vendorDetail.commissionType;
    commissionValue = state.vendor.vendorDetail.commissionValue;
    vendorCurrency = state.vendor.vendorDetail.currency;
  }
  let adminCommissionType = "Fixed";
  let adminCommissionValue = 0;
  if (
    state.admin &&
    state.admin.commission &&
    state.admin.commission.commissionType
  ) {
    adminCommissionType = state.admin.commission.commissionType;
    adminCommissionValue = state.admin.commission.commissionValue;
  }
  return {
    commissionType: commissionType,
    commissionValue: commissionValue,
    vendorCurrency,
    adminCommissionType,
    adminCommissionValue,
  };
};

export default connect(mapStateWithProps)(Baggage);
